import * as API from '@/api/index'
/* 登录 */
export const loginPost = (params) => {
    return API.POST('/A04LoginController/selectUserInfo', params);
}
/* token校验 */
export const checkToken = (params) => {
    return API.POST('/A04LoginController/checkToken', params);
}